<template>
  <div class="contents">
    <div class="d-flex section-title">
      <img src="@/assets/images/Icon billing home_bk.png" alt="" width="27.3" height="25.2" />
      <p class="title-bk">請求</p>
    </div>

    <!-- Filter by time -->
    <div class="container">
      請求を表示する利用月を選択してださい
      <table class="table table-header">
        <tbody>
          <tr>
            <th scope="row" width="10%">利用月：</th>
            <td width="25%">
              <v-select
                tag="div"
                v-model="filteredMonth"
                placeholder="選択してください"
                class="select-control"
                :clearable="false"
                :options="billingDates"
                label="text"
                @input="pickedMonth"
              >
              </v-select>
            </td>
            <td />
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Filter by entities -->
    <div class="container">
      請求を表示する対象を選択して[ 表示 ]を押してください
      <table class="table table-header">
        <tbody>
          <tr>
            <th scope="row" width="10%">対象：</th>
            <td width="25%">
              <v-select
                tag="div"
                v-model="selectedCorporation"
                placeholder="全法人"
                class="select-control"
                :disabled="disableChoosingCorporation"
                :clearable="!disableChoosingCorporation || hasAdminPrivilege"
                :options="corporation.corporations"
                label="name"
                @input="pickedCorporation"
              />
            </td>
            <td width="25%">
              <v-select
                tag="div"
                v-model="selectedBrand"
                placeholder="全ブランド"
                class="select-control"
                :disabled="disableChoosingBrand"
                :clearable="!disableChoosingBrand || hasAdminPrivilege"
                :options="brand.brands"
                label="name"
                @input="pickedBrand"
              />
            </td>
            <td width="25%">
              <v-select
                tag="div"
                v-model="selectedSchool"
                placeholder="全教場"
                class="select-control"
                :disabled="disableChoosingSchool"
                :clearable="!disableChoosingSchool || hasAdminPrivilege"
                :options="school.schools"
                label="name"
                @input="pickedSchool"
              />
            </td>
            <td>
              <div class="filter-button">
                <button
                  type="button"
                  :disabled="!filteredMonth || currentBusyState"
                  class="btn btn-confirm"
                  @click="collectBilling"
                >
                  表示
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 3rd group -->
    <div v-if="isDisplayAllCorporation" class="container admin-container">
      明細Excel
      <div class="billing-table table-responsive">
        <table class="table table-header">
          <tbody>
            <tr>
              <th>
                <div class="text-nowrap admin-custom-header">利用月</div>
              </th>
              <th>
                <div class="text-nowrap admin-custom-header">対象</div>
              </th>
              <th>
                <div class="text-nowrap admin-custom-header">前回の判定修正日時</div>
              </th>
              <th>
                <div class="text-nowrap admin-custom-header">アクション</div>
              </th>
            </tr>
            <tr>
              <td>
                <div class="text-nowrap admin-custom-row">{{ filteredMonth.text }}</div>
              </td>
              <td>
                <div class="text-nowrap admin-custom-row">全法人</div>
              </td>
              <td>
                <div class="text-nowrap admin-custom-row">{{ billingStatusChangeDateDisplay }}</div>
              </td>
              <td>
                <div class="text-nowrap admin-custom-row">
                  <button
                    type="button"
                    class="btn btn-confirm btn-admin-export"
                    :disabled="!filteredMonth || currentBusyState"
                    @click="generateExcel"
                  >
                    Excelダウンロード
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      ※ システム上でExcel未生成の場合や、生成後に判定修正された場合は、メールでExcelをお送りします
    </div>
    <div v-else class="container">
      <BillingHeaderView />

      <div class="form-group float-right">
        <button type="button" :disabled="!canExportToExcel" class="btn btn-confirm btn-export" @click="exportToExcel">
          明細Excel出力
        </button>
        <br />
        <button type="button" :disabled="!canExportToPdf" class="btn btn-confirm btn-export" @click="exportToPdf">
          請求書PDF出力
        </button>
      </div>

      <BillingDataTable
        class="billing-data-display-holder"
        :filtered-month-display="filteredMonthDisplay"
        :selected-corporation="selectedCorporation"
        :selected-brand="selectedBrand"
        :selected-school="selectedSchool"
        :should-display-total-fee="shouldDisplayTotalFee"
        :current-busy-state="currentBusyState"
        :current-busy-display="currentBusyDisplay"
        @goToBillingPage="goToBillingPage"
        @showDetailsPopupHolder="showDetailsPopupHolder"
      />
    </div>

    <PopUpHolder
      ref="detail_popup_holder"
      no-close-on-esc
      no-close-on-backdrop
      popup-size="xl"
      green-button-title="閉じる"
      @greenClick="detailPopupCancelled"
    >
      <template v-slot:header v-if="studentBillingPopupReady">請求対象生徒ID一覧</template>
      <template v-slot:header v-else-if="teacherBillingPopupReady">請求対象先生ID一覧</template>

      <template v-slot:body v-if="studentBillingPopupReady">
        <StudentBillingDetailTable
          :filtered-month-name="filteredMonthDisplay"
          :selected-corporation-name="selectedCorporationNameDisplay"
          :billing-item="currentBilling"
          @changeStudentBillingDetail="showStudentBillingDetailToChange"
        />
      </template>
      <template v-slot:body v-else-if="teacherBillingPopupReady">
        <TeacherBillingDetailTable
          :filtered-month-name="filteredMonthDisplay"
          :selected-corporation-name="selectedCorporationNameDisplay"
          :billing-item="currentBilling"
          @changeTeacherBillingDetail="showTeacherBillingDetailToChange"
        />
      </template>
    </PopUpHolder>

    <PopUpHolder
      ref="status_popup_holder"
      no-close-on-esc
      no-close-on-backdrop
      show-red-button
      red-button-title="修正する"
      green-button-title="閉じる"
      @greenClick="statusPopupCancelled"
      @redClick="statusPopupConfirmed"
    >
      <template v-slot:header v-if="studentBillingPopupReady">判定修正</template>
      <template v-slot:header v-else-if="teacherBillingPopupReady">判定修正</template>>

      <template v-slot:body v-if="studentBillingPopupReady">
        <StudentBillingStatusPicker :billing-detail="currentBillingDetail" />
      </template>
      <template v-slot:body v-else-if="teacherBillingPopupReady">
        <TeacherBillingStatusPicker :billing-detail="currentBillingDetail" />
      </template>
    </PopUpHolder>
    <div ref="billing-data-export" v-show="exportingPdf" class="billing-data-fixed-container">
      <BillingHeaderView show-current-date />
      <BillingDataTable
        :filtered-month-display="filteredMonthDisplay"
        :selected-corporation="selectedCorporation"
        :selected-brand="selectedBrand"
        :selected-school="selectedSchool"
        :should-display-total-fee="shouldDisplayTotalFee"
        show-recipient-details
      />
    </div>
    <PopUpHolder
      ref="billing_0625_not_available_popup_holder"
      no-close-on-esc
      no-close-on-backdrop
      green-button-title="閉じる"
      @greenClick="billing0625NotAvailablePopupConfirmed"
    >
      <template v-slot:header>2021/6/25</template>
      <template v-slot:body>今回のデータは取得いたしませんでした。</template>
    </PopUpHolder>
    <PopUpHolder
      ref="billing_generate_excel_popup_holder"
      no-close-on-esc
      no-close-on-backdrop
      green-button-title="閉じる"
      @greenClick="billingGenerateExcelPopupConfirmed"
    >
      <template v-slot:header>ダウンロード受付完了</template>
      <template v-slot:body>
        <p>
          全法人のデータのExcelダウンロードを受け付けました。<br />
          データはメールでお送りします。<br />
          しばらく時間をおいてからメールボックスをご確認ください。
        </p>
      </template>
    </PopUpHolder>
    <PopUpHolder
      ref="billing_generate_excel_error_popup_holder"
      no-close-on-esc
      no-close-on-backdrop
      green-button-title="閉じる"
      @greenClick="billingGenerateExcelErrorPopupConfirmed"
    >
      <template v-slot:header>エラー</template>
      <template v-slot:body>
        <p>
          全法人のデータのExcelダウンロードでエラーが発生しました。<br />
          お手数ですがシステム班へご連絡ください。
        </p>
      </template>
    </PopUpHolder>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import PopUpHolder from '@/components/popups/PopUpHolder.vue';
import EventBus from '@/helpers/EventBus.js';
import StudentBillingDetailTable from '@/views/billings/forms/StudentBillingDetailTable.vue';
import TeacherBillingDetailTable from '@/views/billings/forms/TeacherBillingDetailTable.vue';
import StudentBillingStatusPicker from '@/views/billings/forms/StudentBillingStatusPicker.vue';
import TeacherBillingStatusPicker from '@/views/billings/forms/TeacherBillingStatusPicker.vue';
import BillingHeaderView from '@/views/billings/forms/BillingHeaderView.vue';
import BillingDataTable from '@/views/billings/forms/BillingDataTable.vue';
import { basicFieldPresent } from '@/presenters/fields';
import cloneDeep from 'lodash/cloneDeep';
import XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import first from 'lodash/first';
import store from '@/store/index.js';
import filter from 'lodash/filter';
import moment from 'moment-timezone';

export default {
  props: {
    corporationId: {
      type: [String, Number],
      required: false,
    },
    brandId: {
      type: [String, Number],
      required: false,
    },
    schoolId: {
      type: [String, Number],
      required: false,
    },
    preFilteredMonth: {
      type: [String, String],
      required: false,
    },
  },
  components: {
    PopUpHolder,
    StudentBillingDetailTable,
    TeacherBillingDetailTable,
    StudentBillingStatusPicker,
    TeacherBillingStatusPicker,
    BillingHeaderView,
    BillingDataTable,
  },
  data() {
    return {
      filteredMonth: null,
      selectedCorporation: null,
      selectedBrand: null,
      selectedSchool: null,
      currentBilling: null,
      currentBillingDetail: null,
      currentBusyState: false,
      isDisplayAllCorporation: false,
      exportingPdf: false,
      shouldReloadAfterDataChanged: false,
    };
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    // Note: does not have access to 'this'
    store.dispatch('billing/clearBillings');
    if (routeTo.params.corporationId) {
      store.dispatch('corporation/fetchCorporation', routeTo.params.corporationId).then(() => {
        next();
      });
    } else if (routeTo.params.brandId) {
      store.dispatch('brand/fetchBrand', routeTo.params.brandId).then(() => {
        next();
      });
    } else if (routeTo.params.schoolId) {
      store.dispatch('school/fetchSchool', routeTo.params.schoolId).then(() => {
        next();
      });
    } else {
      next();
    }
  },
  async mounted() {
    if (this.preFilteredMonth) {
      this.$logger.debug('Use preFilteredMonth ' + this.preFilteredMonth);
      this.filteredMonth = {
        text: moment(this.preFilteredMonth, 'YYYYMMDD').format('YYYY年MM月DD日'),
        value: this.preFilteredMonth,
      };
    } else {
      // 利用月が入っていないときは、ブランド・教場をリセットする
      this.clearBrands();
      this.clearSchools();
    }

    if (this.loggedInAsSchool || this.schoolId) {
      if (this.schoolId && this.school.school.id != this.schoolId) {
        await store.dispatch('school/fetchSchool', this.schoolId);
      }

      this.selectedCorporation = this.school.school.corporation;
      this.selectedBrand = this.school.school.brand;
      this.selectedSchool = this.school.school;
    } else if (this.loggedInAsBrand || this.brandId) {
      if (this.brandId && this.brand.brand.id != this.brandId) {
        await store.dispatch('brand/fetchBrand', this.brandId);
      }
      this.selectedCorporation = this.brand.brand.corporation;
      this.selectedBrand = this.brand.brand;
      this.fetchSchools({ data: { filterBy: { brandId: this.selectedBrand.id } } });
    } else if (this.loggedInAsCorporation || this.corporationId) {
      this.selectedCorporation = this.corporation.corporation;
      this.fetchBrands({ data: { filterBy: { corporationId: this.selectedCorporation.id } } });
    } else {
      this.fetchCorporations();
    }

    if ((this.corporationId || this.brandId || this.schoolId) && this.filteredMonth) {
      this.$logger.debug('So we can just start to fetch data');
      this.collectBilling();
    }

    EventBus.$on('SET_USER_PROFILE', this.setCurrentRoleHandler);
  },
  beforeDestroy() {
    EventBus.$off('SET_USER_PROFILE', this.setCurrentRoleHandler);
  },
  computed: {
    billingDates() {
      const numberOfMonths = 12;
      const arrayOfBillingDates = [];
      for (let index = 0; index < numberOfMonths; index++) {
        const endOfMonth = moment()
          .subtract(index + 1, 'months')
          .endOf('month');
        const endOfMonthElement = {
          value: endOfMonth.format('YYYYMMDD'),
          text: endOfMonth.format('YYYY年MM月DD日'),
        };

        // Workaround for the issue in which 20210630 bill wasn't created, and the alternative bill was made on 1/July.
        if (endOfMonthElement.value == 20210630) {
          arrayOfBillingDates.push({
            value: '20210701',
            text: endOfMonth.format('2021年07月01日'),
          });
        } else {
          arrayOfBillingDates.push(endOfMonthElement);
        }

        const specificDateOfMonth = moment()
          .subtract(index + 1, 'months')
          .date('25');
        const specificDateOfMonthElement = {
          value: specificDateOfMonth.format('YYYYMMDD'),
          text: specificDateOfMonth.format('YYYY年MM月DD日'),
        };
        arrayOfBillingDates.push(specificDateOfMonthElement);
      }
      const currentDay = moment().format('DD');
      if (['26', '27', '28', '29', '30', '31'].includes(currentDay)) {
        const billingDate = moment().date('25');
        const currentBillingDate = {
          value: billingDate.format('YYYYMMDD'),
          text: billingDate.format('YYYY年MM月DD日'),
        };
        arrayOfBillingDates.unshift(currentBillingDate);
      }
      const result = filter(arrayOfBillingDates, (billingDate) => Number(billingDate.value) >= Number('20210525'));
      return result;
    },
    filteredMonthDisplay() {
      return this.filteredMonth ? this.filteredMonth.text + '（自動集計）' : '―';
    },
    currentBusyDisplay() {
      if (this.isLoadingMore && this.totalBillingsToLoadMore > 0) {
        return `データのロード ${this.totalBillingIds} / ${this.totalBillingsToLoadMore}`;
      }
      return 'データのロード...';
    },
    exportDateDisplay() {
      return `${this.exportDate.year}年${this.exportDate.month}月${this.exportDate.day}日`;
    },
    disableChoosingCorporation() {
      if (this.hasAdminPrivilege && this.filteredMonth) {
        return false;
      }
      return (
        this.loggedInAsCorporation ||
        this.loggedInAsBrand ||
        this.loggedInAsSchool ||
        this.filteredMonth == null ||
        this.corporationId != null ||
        this.brandId != null ||
        this.schoolId != null
      );
    },
    disableChoosingBrand() {
      if (this.hasAdminPrivilege && this.filteredMonth) {
        return false;
      }
      return (
        this.loggedInAsBrand ||
        this.loggedInAsSchool ||
        this.filteredMonth == null ||
        this.brandId != null ||
        this.schoolId != null
      );
    },
    disableChoosingSchool() {
      if (this.hasAdminPrivilege && this.filteredMonth) {
        return false;
      }
      return this.loggedInAsSchool || this.filteredMonth == null || this.schoolId != null;
    },
    selectedCorporationNameDisplay() {
      return basicFieldPresent(this.selectedCorporation, 'name');
    },
    selectedBrandNameDisplay() {
      return basicFieldPresent(this.selectedBrand, 'name');
    },
    selectedSchoolNameDisplay() {
      return basicFieldPresent(this.selectedSchool, 'name');
    },
    studentBillingPopupReady() {
      return (
        this.currentBilling &&
        [
          'studentKiwami1',
          'studentKiwami2',
          'studentKokugo',
          'studentAsobi',
          'studentSatori',
          'student1',
          'student2',
        ].includes(this.currentBilling.billingTypeId)
      );
    },
    teacherBillingPopupReady() {
      return this.currentBilling && this.currentBilling.billingTypeId == 'teacher';
    },
    shouldDisplayTotalFee() {
      return this.totalBillings > 0 && this.reviewingDataInsideOneCorporation();
    },
    canExportToExcel() {
      return this.totalBillings > 0 && !this.currentBusyState;
    },
    canExportToPdf() {
      return this.totalBillings > 0 && !this.currentBusyState && this.reviewingDataInsideOneCorporation();
    },
    billingStatusChangeDateDisplay() {
      return this.updateDate ? moment(this.updateDate).format('YYYY年M月D日 HH:mm') : 'ー';
    },
    canDownloadToExcel() {
      if (!this.billingExcel || moment(this.billingExcel.LastModified).isBefore(moment(this.updateDate))) {
        return false;
      }
      return true;
    },
    ...mapState(['corporation']),
    ...mapState(['brand']),
    ...mapState(['school']),
    ...mapState({
      billings: (state) => state.billing.billings,
      exportDate: (state) => state.billing.exportDate,
      billingExcel: (state) => state.billing.billingExcel,
      updateDate: (state) => state.billing.updateDate,
    }),
    ...mapGetters('billing', [
      'totalBillings',
      'totalBillingIds',
      'totalBillingsToLoadMore',
      'canLoadMoreBillings',
      'getExcelFormattedBillings',
      'getExcelHeaderBillings',
      'getExcelHeaderHashBillings',
    ]),
    ...mapGetters('auth', ['loggedInAsCorporation', 'loggedInAsBrand', 'loggedInAsSchool']),
    ...mapGetters('role', ['hasAdminPrivilege']),
  },
  methods: {
    pickedMonth() {
      this.clearBillings();
      this.isDisplayAllCorporation = false;
    },
    pickedCorporation() {
      if (this.selectedCorporation) {
        this.$logger.debug('Picked Corporation: ' + this.selectedCorporation.id);
        this.fetchBrands({ data: { filterBy: { corporationId: this.selectedCorporation.id } } });
      }

      this.selectedBrand = null;
      this.selectedSchool = null;

      this.clearBrands();
      this.clearSchools();
      this.clearBillings();
    },
    pickedBrand() {
      if (this.selectedBrand) {
        this.$logger.debug('Picked Brand: ' + this.selectedBrand.id);
        this.fetchSchools({ data: { filterBy: { brandId: this.selectedBrand.id } } });
      }

      this.selectedSchool = null;

      this.clearSchools();
      this.clearBillings();
    },
    pickedSchool() {
      if (this.selectedSchool) {
        this.$logger.debug('Picked School: ' + this.selectedSchool.id);
      }

      this.clearBillings();
    },
    goToBillingPage(payload) {
      this.$logger.debug('Go to billing detail page:' + JSON.stringify(payload) + ', at: ' + this.filteredMonth.value);
      switch (payload.billingType) {
        case 'corporation':
          this.$router.push({
            name: 'billing-corporation-id',
            params: { corporationId: payload.billingId, preFilteredMonth: this.filteredMonth.value },
          });
          break;
        case 'brand':
          this.$router.push({
            name: 'billing-brand-id',
            params: { brandId: payload.billingId, preFilteredMonth: this.filteredMonth.value },
          });
          break;
        case 'school':
          this.$router.push({
            name: 'billing-school-id',
            params: { schoolId: payload.billingId, preFilteredMonth: this.filteredMonth.value },
          });
          break;
        default:
          break;
      }
    },
    showDetailsPopupHolder(currentBilling) {
      this.currentBilling = currentBilling;
      this.$refs['detail_popup_holder'].show();
    },
    detailPopupCancelled() {
      this.$logger.debug('Close detail popup');
      if (this.shouldReloadAfterDataChanged) {
        this.$logger.debug('Reload data after data changed');
        this.shouldReloadAfterDataChanged = false;
        this.collectBilling();
      }
    },
    statusPopupConfirmed() {
      const data = {
        id: this.currentBillingDetail.id,
        status: this.currentBillingDetail.status,
      };

      if (this.currentBillingDetail.teacherId) {
        data.uid = this.currentBillingDetail.teacherId;
        data.type = 'teacher';
      }

      if (this.currentBillingDetail.studentId) {
        data.uid = this.currentBillingDetail.studentId;
        data.type = 'student';
      }

      this.$logger.debug('Submit billing data ' + JSON.stringify(data));
      this.showLoading();
      this.updateBillingStatus({ data }).catch((error) => {
        this.$logger.debug('Update billing status fail. Details: ' + error.response.data.error);
      });

      this.shouldReloadAfterDataChanged = true;
      this.$refs['detail_popup_holder'].show();
    },
    statusPopupCancelled() {
      this.$logger.debug("Don't save billing status " + this.currentBillingDetail.status);
      this.$refs['detail_popup_holder'].show();
    },
    billing0625NotAvailablePopupConfirmed() {
      this.$logger.debug('Billing Not Available Popup done');
    },
    billingGenerateExcelPopupConfirmed() {
      this.$logger.debug('Billing Generate Excel Popup done');
    },
    billingGenerateExcelErrorPopupConfirmed() {
      this.$logger.debug('Billing Generate Excel Error Popup done');
    },
    useOldBillingSchemas() {
      return Number(this.filteredMonth.value) <= Number('20210531');
    },
    async collectBilling() {
      const params = {
        year: moment(this.filteredMonth.value, 'YYYYMMDD').format('YYYY'),
        month: moment(this.filteredMonth.value, 'YYYYMMDD').format('MM'),
        day: moment(this.filteredMonth.value, 'YYYYMMDD').format('DD'),
      };

      if (params.year == 2021 && params.month == 6 && params.day == 25) {
        this.$refs['billing_0625_not_available_popup_holder'].show();
        return;
      }

      let selectAllCorporation = true;
      let needReformatId = this.useOldBillingSchemas();
      if (this.selectedCorporation) {
        params['corporationId'] = this.selectedCorporation.id;
        if (needReformatId) {
          params['corporationUid'] = this.selectedCorporation.uid;
        }
        selectAllCorporation = false;
      }
      if (this.selectedBrand) {
        params['brandId'] = this.selectedBrand.id;
        if (needReformatId) {
          params['brandUid'] = this.selectedBrand.uid;
        }
        selectAllCorporation = false;
      }
      if (this.selectedSchool) {
        params['schoolId'] = this.selectedSchool.id;
        if (needReformatId) {
          params['schoolUid'] = this.selectedSchool.uid;
        }
        selectAllCorporation = false;
      }
      this.$logger.debug('Request billing for ' + JSON.stringify(params));

      if (selectAllCorporation) {
        this.clearBillings();
        this.currentBusyState = true;
        await this.fetchExcel({ data: params }); // Excelを取得
        this.currentBusyState = false;
        this.isDisplayAllCorporation = true;
      } else {
        this.clearBillings();
        this.currentBusyState = true;
        this.isDisplayAllCorporation = false;
        this.fetchBillings({ data: params }).finally(() => {
          this.currentBusyState = false;
        });
      }
    },
    reviewingDataInsideOneCorporation() {
      return first(this.billings).billingType != 'corporation';
    },
    async generateExcel() {
      const params = {
        year: moment(this.filteredMonth.value, 'YYYYMMDD').format('YYYY'),
        month: moment(this.filteredMonth.value, 'YYYYMMDD').format('MM'),
        day: moment(this.filteredMonth.value, 'YYYYMMDD').format('DD'),
      };
      if (params.year == 2021 && params.month == 6 && params.day == 25) {
        this.$refs['billing_0625_not_available_popup_holder'].show();
        return;
      }
      this.$logger.debug('Request billing for ' + JSON.stringify(params));
      this.clearBillings();
      this.currentBusyState = true;
      await this.fetchExcel({ data: params });

      if (this.canDownloadToExcel) {
        const workbook = XLSX.read(this.billingExcel.Body.data, {
          type: 'buffer',
        });
        XLSX.writeFile(workbook, 'billings_' + this.filteredMonth.value + '.xlsx');
      } else {
        await this.callExcelGeneration({ data: params })
          .then(() => {
            this.$refs['billing_generate_excel_popup_holder'].show();
          })
          .catch(() => {
            this.$refs['billing_generate_excel_error_popup_holder'].show();
          });
      }
      this.currentBusyState = false;
    },
    exportToExcel() {
      this.$logger.debug('Export Billings to Excel');
      let excelFormattedBillings = cloneDeep(this.getExcelFormattedBillings);
      excelFormattedBillings.unshift(this.getExcelHeaderHashBillings);
      excelFormattedBillings.unshift({});
      const selectedScopes = [
        {
          title: '',
          value: this.selectedSchoolNameDisplay,
        },
        {
          title: '',
          value: this.selectedBrandNameDisplay,
        },
        {
          title: '御法人名：',
          value: this.selectedCorporationNameDisplay,
        },
        {
          title: '御利用月：',
          value: this.filteredMonthDisplay,
        },
      ];
      for (const scope of selectedScopes) {
        excelFormattedBillings.unshift({
          No: scope.title,
          区分: scope.value,
        });
      }
      excelFormattedBillings.unshift({
        No: 'KIWAMI AAA+ ID使用料 御請求書',
        単価: '発行日',
        合計: this.exportDateDisplay,
      });
      var billingWS = XLSX.utils.json_to_sheet(excelFormattedBillings, {
        header: this.getExcelHeaderBillings,
        skipHeader: true,
      });
      var wb = XLSX.utils.book_new(); // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, billingWS, 'Billings'); // add Worksheet to Workbook
      XLSX.writeFile(wb, 'billings.xlsx');
    },
    async exportToPdf() {
      this.$logger.debug('Print Billings to PDF');
      this.exportingPdf = true;
      const options = { type: 'dataURL' };
      const imageData = await this.$html2canvas(this.$refs['billing-data-export'], options);
      const imageWidth = this.$refs['billing-data-export'].clientWidth;
      const imageHeight = this.$refs['billing-data-export'].clientHeight;
      this.$logger.debug('Billing Table Size: ' + imageWidth + ' - ' + imageHeight);
      this.exportingPdf = false;

      let doc = new jsPDF({ orientation: 'p', format: 'a4' });
      doc.autoPrint();
      const pdfWidth = doc.internal.pageSize.getWidth();
      const pdfHeight = doc.internal.pageSize.getHeight();
      this.$logger.debug('PDF Page Size: ' + pdfWidth + ' - ' + pdfHeight);

      const expectedImageWidth = pdfWidth;
      let expectedImageHeight = (expectedImageWidth * imageHeight) / imageWidth;
      this.$logger.debug('Expected Image Size: ' + expectedImageWidth + ' - ' + expectedImageHeight);

      if (expectedImageHeight < pdfHeight) {
        doc.addImage(imageData, 0, 0, expectedImageWidth, expectedImageHeight);
      } else {
        let heightPosition = 4; // Start position for the 1st page
        let pageOffset = 0;
        let heightLeft = expectedImageHeight;
        this.$logger.debug('Page 1 Height left', heightLeft);

        doc.addImage(imageData, 0, heightPosition, expectedImageWidth, expectedImageHeight);
        heightLeft -= pdfHeight;

        const topPadding = 7; // Start position for next pages, with offset below
        while (heightLeft >= 0) {
          pageOffset++;
          heightPosition = topPadding + pageOffset + heightLeft - expectedImageHeight;
          doc.addPage();
          doc.addImage(imageData, 0, heightPosition, expectedImageWidth, expectedImageHeight);
          heightLeft -= pdfHeight;
          this.$logger.debug('Next Page Height left', heightLeft);
          this.$logger.debug('Next Page Position', heightPosition);
        }
      }

      doc.save('billings.pdf', { returnPromise: true }).then(() => {
        this.$logger.debug('PDF saved successfully');
      });
    },
    showStudentBillingDetailToChange(billingDetail) {
      this.$logger.debug('Show billing status changing for Student billingTypeId ' + billingDetail.id);
      this.$refs['detail_popup_holder'].hide();
      this.currentBillingDetail = cloneDeep(billingDetail);
      this.$refs['status_popup_holder'].show();
    },
    showTeacherBillingDetailToChange(billingDetail) {
      this.$logger.debug('Show billing status changing for Teacher billingTypeId ' + billingDetail.id);
      this.$refs['detail_popup_holder'].hide();
      this.currentBillingDetail = cloneDeep(billingDetail);
      this.$refs['status_popup_holder'].show();
    },
    setCurrentRoleHandler(payload) {
      if (this.loggedInAsSchool) {
        this.selectedSchool = payload.data;
        this.selectedBrand = payload.data.brand;
        this.selectedCorporation = payload.data.corporation;
      } else if (this.loggedInAsBrand) {
        this.selectedBrand = payload.data;
        this.selectedCorporation = payload.data.corporation;
        this.fetchSchools({ data: { filterBy: { brandId: this.selectedBrand.id } } });
      } else if (this.loggedInAsCorporation) {
        this.selectedCorporation = payload.data;
        this.fetchBrands({ data: { filterBy: { corporationId: this.selectedCorporation.id } } });
      }
    },
    ...mapActions('corporation', ['fetchCorporations']),
    ...mapActions('brand', ['fetchBrands', 'clearBrands']),
    ...mapActions('school', ['fetchSchools', 'clearSchools']),
    ...mapActions('billing', [
      'fetchBillings',
      'fetchAndAppendBillings',
      'fetchExcel',
      'callExcelGeneration',
      'clearBillings',
      'updateBillingStatus',
    ]),
    ...mapActions('loading', ['showLoading']),
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding-bottom: 10px;
}
.table-header {
  margin-top: 15px;
}
.table-header th,
.table-header td {
  vertical-align: middle;
}
.btn-confirm {
  margin: 2px 0px 2px 0px;
}
.filter-button {
  text-align: right;
  padding-right: 5px;
}
.btn-export {
  width: 180px;
  margin-right: 15px;
}
.select-control {
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 12px;
}
.billing-data-fixed-container {
  width: 805px;
  padding: 10px;
}
.billing-data-display-holder {
  padding-right: 10px;
}

.admin-container {
  padding-bottom: 30px;
}

.admin-custom-header {
  background-color: #7e7964;
  color: white;
  padding: 5px 10px 5px 10px;
}
.admin-custom-row {
  height: 60px;
  padding: 10px;
  background: #eeeeee;
  display: flex;
  align-items: center;
}

.btn-admin-export {
  margin-right: 15px;
}
</style>
